import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { STRIPE_PUBLIC_KEY } from 'constants/stripe';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Content, { PaymentContentRef } from './content';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

interface IProps {
    headerChildren?: React.ReactNode;
    title?: string;
    email?: string;
    paymentMehodDescription?: string;
    confirmButtonText?: string;
    hidePolicy?: boolean;
    // 隐藏 email + 付款方式表单，只保留 Platform agreement；确认走 onConfirm（如 without-payment list）
    hidePayment?: boolean;
    onConfirm?: () => Promise<void> | void;
    onSuccess?: () => void;
    isPPV?: boolean;
    onPaymentMethodCreated?: (paymentMethodId: string) => void;
    buttonClassName?: string;
}

const Wrapper = forwardRef<PaymentContentRef, IProps>(({
    headerChildren,
    title,
    email,
    paymentMehodDescription,
    confirmButtonText,
    hidePolicy = false,
    hidePayment = false,
    onConfirm,
    onSuccess,
    isPPV = false,
    onPaymentMethodCreated,
    buttonClassName,
}, ref) => {
    const contentRef = useRef<PaymentContentRef>(null);

    useImperativeHandle(ref, () => ({
        onSubmit: () => {
            return contentRef.current?.onSubmit() || Promise.resolve();
        },
    }), []);

    return (
        <Elements stripe={stripePromise}>
            <Content
                ref={contentRef}
                headerChildren={headerChildren}
                title={title}
                email={email}
                paymentMehodDescription={paymentMehodDescription}
                confirmButtonText={confirmButtonText}
                hidePolicy={hidePolicy}
                hidePayment={hidePayment}
                onConfirm={onConfirm}
                onSuccess={onSuccess}
                isPPV={isPPV}
                onPaymentMethodCreated={onPaymentMethodCreated}
                buttonClassName={buttonClassName}
            />
        </Elements>
    );
});

Wrapper.displayName = 'PaymentContentWrapper';

export default Wrapper;
export type { PaymentContentRef };
